import * as React from 'react';

import { type Breadcrumb, GenericHeroImage } from '@lendi-jam/generic-hero-image';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import parse, { domToReact } from 'html-react-parser';

import { ContentHeroImageContent } from '#contentTypes/ContentHeroImage';

interface PrismicHeroImageProps {
  component: ContentHeroImageContent;
  breadcrumbs?: Breadcrumb[];
  hideBreadcrumbs?: boolean;
}

const PrismicContentHero: React.FC<PrismicHeroImageProps> = ({ component, breadcrumbs }) => {
  const {
    hero_image_title,
    hero_image_subtitle,
    hide_breadcrumbs,
    hero_image_variant: variant,
    is_full_width,
  } = component.primary;

  return (
    <GenericHeroImage
      breadcrumbs={breadcrumbs}
      hideBreadcrumbs={hide_breadcrumbs}
      subtitle={parse(hero_image_subtitle.html, {
        replace: ({ name, attribs, children }) => {
          if (name === 'a') {
            return <a href={embedMarketingTrackingIntoURL(attribs?.href)}>{children && domToReact(children)}</a>;
          }
          if (name === 'h2') {
            return <>{children[0]?.data}</>;
          }
          return null;
        },
      })}
      title={hero_image_title.text}
      variant={variant}
      isFullWidth={is_full_width}
    />
  );
};

export default PrismicContentHero;
